import Emitter from 'component-emitter'
export default new Emitter()
